import { Response } from "@version2/domain-package";

const s500 = {
  GENERAL__ERROR: new Response({
    status: 500,
    code: "general/error",
  }),
};

export default s500;
